<template>
  <a-layout-header class="header gongsiheader" :style="{ background: '#FFF','margin-bottom':'10px' }">
    <a-image
  :width="40"
  src="https://img.alicdn.com/imgextra/i1/698818285/O1CN01PHKt922B4a2zYyLaj_!!698818285.png"
  class="gongsilogo"

    />
    <a-typography-text class="gongsiname" >商鱼代打</a-typography-text>
    <a-typography-text class="loginnick" >登录店铺：<span>{{ shopname }}</span></a-typography-text>
    <a href="https://fuwu.jinritemai.com/detail?service_id=20954" target="_blank">续费</a>
  </a-layout-header>
</template>

<script>
window.shopinfoObj = {}
import { defineComponent, ref } from "vue"; 
import { getMainShop } from '@/request/api';
import { useRouter } from 'vue-router';
export default defineComponent ({
  setup(){
    const router = useRouter()
  },
  created(){
    const url = location.href;
    if(url.indexOf("https://zb.huolangcloud.com.cn") < 0){
      this.getShopName()
    }
  },
  data(){
    return{
      shopname:''
    }
  },
  methods:{
    getShopName(){
      getMainShop().then(res => {
        this.shopname = res.data;
        window.shopinfoObj = res
      })
    }
  }
});
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}
#components-layout-demo-top-side-2 .logo {
  float: left;
  width: 120px;
  height: 31px;
  margin: 16px 24px 16px 0;
  background: rgba(255, 255, 255, 0.3);
  
}

.ant-row-rtl #components-layout-demo-top-side-2 .logo {
  float: right;
  margin: 16px 0 16px 24px;
}

.site-layout-background {
  background: #fff;
}
.loginnick{
  margin-right:  24px;
  margin-left:  48px;
}
</style>
